import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Building2, Zap } from 'lucide-react';

export const HeroSection = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="img/bg-sai.jpeg"
          alt="African Business Excellence"
          className="w-full h-full object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-background1"></div>
      </div>

      {/* Content */}
      <div className="container-custom relative z-10 pt-20">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-primary/10 backdrop-blur-sm border border-primary/30 rounded-full px-4 py-2 mb-6 animate-fade-in">
            <Zap className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">30+ Years of Excellence</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6 animate-slide-up">
            Building Africa's Future
            <span className="block mt-2">
              Across{' '}
              <span className="text-primary">
                Multiple Industries
              </span>
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-foreground/80 leading-relaxed mb-8 max-w-2xl animate-slide-up">
            SAI Group is a pan-African diversified conglomerate driving economic growth through strategic investments in mobility, technology, mining, media, healthcare, and real estate.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-slide-up">
            <Button
              size="lg"
              className="bg-primary hover:bg-primary/90 text-primary-foreground btn-hover-lift text-base"
              onClick={() => scrollToSection('#companies')}
            >
              Explore Our Companies
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground text-base"
              onClick={() => scrollToSection('#about')}
            >
              Learn More
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mt-12 pt-12 border-t border-border">
            <div className="animate-fade-in">
              <div className="text-3xl sm:text-4xl font-bold text-primary mb-1">6</div>
              <div className="text-sm text-foreground/70">Core Industries</div>
            </div>
            <div className="animate-fade-in" style={{ animationDelay: '0.1s' }}>
              <div className="text-3xl sm:text-4xl font-bold text-primary mb-1">6</div>
              <div className="text-sm text-foreground/70">Active Companies</div>
            </div>
            <div className="animate-fade-in" style={{ animationDelay: '0.2s' }}>
              <div className="text-3xl sm:text-4xl font-bold text-primary mb-1">Pan-African</div>
              <div className="text-sm  text-foreground/80">Market Reach</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background1 to-transparent1 z-10"></div>
    </section>
  );
};

export default HeroSection;